import Box from '@mui/material/Box';

export const UploadFile = ({ handleFileChange }: { handleFileChange: any }) => {
  return (
    <Box className='flex items-center justify-center w-full cursor-pointer'>
      <input
        onChange={handleFileChange}
        className='block w-full text-sm text-white border border-gray-300 rounded-lg cursor-pointer bg-base-base focus:outline-none'
        aria-describedby='file_input_help'
        id='file_input'
        type='file'
      />
    </Box>
  );
};
